import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import type { Deal } from '@openx/types/deal';
import { useTranslation } from 'react-i18next';

import type { DealDetailsSectionProps } from '../../../types';
import type { IUseRelatedAccountsFetch } from '../../utils/context/DealHookTypes';

export type OnBehalfOfDetailsSectionDeal = Pick<Deal, 'account_uid'>;

export function OnBehalfOfDetailsSection<T extends OnBehalfOfDetailsSectionDeal = OnBehalfOfDetailsSectionDeal>({
  deal,
  historyMode,
  useRelatedAccountsFetch,
}: DealDetailsSectionProps<T> & { useRelatedAccountsFetch: IUseRelatedAccountsFetch }) {
  const { t } = useTranslation();

  const { mapById: relatedAccounts = {}, loading: relatedAccountsLoading } = useRelatedAccountsFetch(deal);

  const name = relatedAccounts[deal.account_uid]?.name;

  return (
    <FormSection divider historyMode={historyMode} title={t('On Behalf Of')}>
      <FieldDetails loading={relatedAccountsLoading} title={t('Account for Deal')} value={name} />
    </FormSection>
  );
}
